import { useState, useEffect, useCallback, useMemo } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useFormState } from 'hooks/useFormState'
import { useVestigioService } from 'hooks/useVestigioService'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'

const schema = {
  lacre: {
    presence: { allowEmpty: false, message: '^Lacre é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: '^Descrição é obrigatório' },
  },
  exReal: {
    presence: {
      allowEmpty: false,
      message: '^Exame realizado que extraiu o vestígio é obrigatório',
    },
  },
}

export const useConsumirVestigio = () => {
  const router = useRouter()
  const params = useParams()
  const vestigioService = useVestigioService()
  const exameRealizadoService = useExameRealizadoService()

  const [abrirEspelho, setAbrirEspelho] = useState(false)
  const [examesDoCaso, setExamesDoCaso] = useState([])
  const [processando, setProcessando] = useState(false)

  const formExameDoCaso = useFormState(schema, {
    lacre: '',
    observacao: '',
    exReal: null,
  })

  const fetchExamesDoCaso = useCallback(async () => {
    try {
      const response = await exameRealizadoService.listarExamesRealizadosNosCasosDeVestigioAsync(params.id, setProcessando)
      setExamesDoCaso(response || [])
    } catch (error) {
      console.error('Erro ao listar exames do caso:', error)
      setExamesDoCaso([])
    }
  }, [params.id])

  const fetchVestigio = useCallback(async () => {
    try {
      const vestigio = await vestigioService.listarVestigioAsync(params.id)
      if (vestigio?.id) {
        formExameDoCaso.setFormState((prevState) => ({
          ...prevState,
          values: {
            ...prevState.values,
            lacre: vestigio.lacre || '',
          },
        }))
      }
    } catch (error) {
      console.error('Erro ao buscar vestígio:', error)
    }
  }, [params.id])

  const handleConfirmar = useCallback(async () => {
    try {
      setProcessando(true)
      await vestigioService.consumirVestigio(params.id, formExameDoCaso.formState.values)
      router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)
    } catch (error) {
      console.error('Erro ao consumir vestígio:', error)
    } finally {
      setProcessando(false)
    }
  }, [params.id, formExameDoCaso.formState.values, router])

  const handleOpen = useCallback(() => {
    setAbrirEspelho(true)
  }, [])

  const handleClose = useCallback(() => {
    setAbrirEspelho(false)
  }, [])

  useEffect(() => {
    fetchExamesDoCaso()
  }, [fetchExamesDoCaso])

  useEffect(() => {
    fetchVestigio()
  }, [fetchVestigio])

  const isFormValid = useMemo(() => {
    return !!(
      formExameDoCaso.formState.values.lacre &&
      formExameDoCaso.formState.values.observacao?.trim() &&
      formExameDoCaso.formState.values.exReal?.id
    )
  }, [formExameDoCaso.formState.values])

  return {
    formExameDoCaso,
    examesDoCaso,
    processando,
    abrirEspelho,
    setAbrirEspelho,
    handleOpen,
    handleClose,
    handleConfirmar,
    isFormValid,
    router,
    params,
  }
}
